import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Subject } from 'rxjs';
import { AdminSettingsService } from './admin-settings.service';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private dialogVisibleSub = new BehaviorSubject<any>({});
  public dialogVisibleObs$ = this.dialogVisibleSub.asObservable();
  menu = new Subject<any>();
  client = new Subject<any>();
  ticketTab = new Subject<any>();

  private menuAction = new BehaviorSubject(true);
  currentMenuAction = this.menuAction.asObservable();

  private shipmentList = new BehaviorSubject('');
  public currentShipmentList = this.shipmentList.asObservable();

  private customerList = new BehaviorSubject('');
  public currentCustomerList = this.customerList.asObservable();

  private claimList = new BehaviorSubject('');
  public currentClaimList = this.claimList.asObservable();

  private sidebarMenu = new BehaviorSubject('');
  public catchSidebarStatus = this.sidebarMenu.asObservable();

  private customerInvoice = new BehaviorSubject('');
  public customerInvoiceStatus = this.customerInvoice.asObservable();

  private salesrepCommission = new BehaviorSubject('');
  public salesrepCommissionStatus = this.salesrepCommission.asObservable();

  private carrierFactorList = new BehaviorSubject('');
  public carrierFactorListStatus = this.carrierFactorList.asObservable();

  private subjectKey = 'jobColor';
  private jobColorSubject = new BehaviorSubject<any>({});
  public jobColor = this.jobColorSubject.asObservable();

  private tlsScoreSubject = new BehaviorSubject<any>({});
  public tlsScore = this.tlsScoreSubject.asObservable();
  //
  private _leadStatusListSubject = new BehaviorSubject<any[]>([]);
  public leadStatusList$ = this._leadStatusListSubject.asObservable();

  private _dealStatusListSubject = new BehaviorSubject<any[]>([]);
  public dealStatusList$ = this._dealStatusListSubject.asObservable();

  private _jobStatusListSubject = new BehaviorSubject<any[]>([]);
  public jobStatusList$ = this._jobStatusListSubject.asObservable();

  // private _defaultRows = new BehaviorSubject<Number>(10);
  // public defaultRows = this._defaultRows.asObservable();

  private _rowsSubject = new BehaviorSubject<number>(10);
  public rows$ = this._rowsSubject.asObservable();

  constructor(private admSettingsService: AdminSettingsService) {
    this.getRowsFromLocalStorage();
  }

  updateMenu(action: any) {
    this.menuAction.next(action);
  }

  showFilteredShipments(status: any) {
    this.shipmentList.next(status);
  }

  showFilteredCustomers(status: any) {
    this.customerList.next(status);
  }

  showClaimData(status: any) {
    this.claimList.next(status);
  }

  hideSidebarMenu(status: any) {
    this.sidebarMenu.next(status);
  }

  showCustomerInvoice(action: any) {
    this.customerInvoice.next(action);
  }

  showCustomerCommission(action: any) {
    this.salesrepCommission.next(action);
  }

  showCarrierFactorList(status: any) {
    this.carrierFactorList.next(status);
  }

  setDialogVisible(data: any) {
    this.dialogVisibleSub.next(data);
  }

  setJobColor(data: any) {
    // console.log('Job color data updated:', data);
    // this.jobColorSubject.next(data);
    localStorage.setItem(this.subjectKey, JSON.stringify(data));
  }

  getSavedJobColor(): any {
    const savedData = localStorage.getItem(this.subjectKey);
    return savedData ? JSON.parse(savedData) : null;
  }

  updateTlsScore(data: any) {
    // console.log('Tls data:', data);
    this.tlsScoreSubject.next(data);
  }

  setRowsInLocalStorage(rows: number) {
    if (rows) {
      localStorage.setItem('tableRows', rows.toString());
      this._rowsSubject.next(rows);
    }
  }

  getRowsFromLocalStorage(): void {
    const savedRows = localStorage.getItem('tableRows');
    const rows = savedRows ? parseInt(savedRows, 10) : 10;
    this._rowsSubject.next(rows);
  }

  // lead status color
  LEAD_STATUS_COLOR_KEY = '_lsc';
  setLeadStatusColor(data: any) {
    localStorage.setItem(this.LEAD_STATUS_COLOR_KEY, JSON.stringify(data));
  }

  getLeadStatusColor(): any {
    const savedData = localStorage.getItem(this.LEAD_STATUS_COLOR_KEY);
    return savedData ? JSON.parse(savedData) : null;
  }

  // deal status color
  DEAL_STATUS_COLOR_KEY = '_dsc';
  setDealStatusColor(data: any) {
    localStorage.setItem(this.DEAL_STATUS_COLOR_KEY, JSON.stringify(data));
  }

  getDealStatusColor(): any {
    const savedData = localStorage.getItem(this.DEAL_STATUS_COLOR_KEY);
    return savedData ? JSON.parse(savedData) : null;
  }

  // job status color
  JOB_STATUS_COLOR_KEY = '_jsc';
  setJobStatusColor(data: any) {
    localStorage.setItem(this.JOB_STATUS_COLOR_KEY, JSON.stringify(data));
  }

  getJobStatusColor(): any {
    const savedData = localStorage.getItem(this.JOB_STATUS_COLOR_KEY);
    return savedData ? JSON.parse(savedData) : null;
  }

  // lead status list
  LEAD_STATUS_LIST_KEY = '_lsl';
  setLeadStatusList(data: any) {
    // set leadList
    this._leadStatusListSubject.next(data);
    localStorage.setItem(this.LEAD_STATUS_LIST_KEY, JSON.stringify(data));
  }
  getLeadStatusList(): any {
    const savedData = localStorage.getItem(this.LEAD_STATUS_LIST_KEY);
    return savedData ? JSON.parse(savedData) : null;
  }

  // deal status list
  DEAL_STATUS_LIST_KEY = '_dsl';
  setDealStatusList(data: any) {
    // set dealList
    this._dealStatusListSubject.next(data);
    localStorage.setItem(this.DEAL_STATUS_LIST_KEY, JSON.stringify(data));
  }
  getDealStatusList(): any {
    const savedData = localStorage.getItem(this.DEAL_STATUS_LIST_KEY);
    return savedData ? JSON.parse(savedData) : null;
  }

  // job status list
  JOB_STATUS_LIST_KEY = '_jls';
  setJobStatusList(data: any) {
    // set jobList
    this._jobStatusListSubject.next(data);
    localStorage.setItem(this.JOB_STATUS_LIST_KEY, JSON.stringify(data));
  }
  getJobStatusList(): any {
    const savedData = localStorage.getItem(this.JOB_STATUS_LIST_KEY);
    return savedData ? JSON.parse(savedData) : null;
  }

  private initAfterLoginDone = new BehaviorSubject(false);
  public initAfterLoginDone$ = this.initAfterLoginDone.asObservable();
  public isInitAfterLoginDone() {
    return this.initAfterLoginDone.getValue();
  }

  initAfterLogin() {
    this.admSettingsService.leadStatusList().subscribe(res => {
      // statusIdColorMap
      let statusIdColorMap: any = res.data?.reduce((acc: any, status: any) => {
        acc[status.name] = status.colorCode;
        acc[status._id] = status.colorCode;
        acc[status.code] = status.colorCode;
        return acc;
      }, {});
      console.log('Status ID Color Map:', statusIdColorMap);
      this.setLeadStatusColor(statusIdColorMap);
      this.setLeadStatusList(res.data);
      this.initAfterLoginDone.next(true);
    });

    this.admSettingsService.dealStatusList().subscribe(res => {
      // dealStatusColorMap
      let dealStatusColorMap: any = res.data?.reduce((acc: any, status: any) => {
        acc[status.name] = status.colorCode;
        acc[status._id] = status.colorCode;
        acc[status.code] = status.colorCode;
        return acc;
      }, {});
      console.log('Status ID Color Map:', dealStatusColorMap);
      this.setDealStatusColor(dealStatusColorMap);
      this.setDealStatusList(res.data);
      this.initAfterLoginDone.next(true);
    });

    this.admSettingsService.jobStatusList().subscribe(res => {
      // jobStatusColorMap
      let jobStatusColorMap: any = res.data?.reduce((acc: any, status: any) => {
        acc[status.name] = status.colorCode;
        acc[status._id] = status.colorCode;
        acc[status.code] = status.colorCode;
        return acc;
      }, {});
      // console.log('Status ID Color Map:', jobStatusColorMap);
      this.setJobStatusColor(jobStatusColorMap);
      this.setJobStatusList(res.data);
      this.initAfterLoginDone.next(true);
    });

    // set lead colors
    let leadColors = this.getLeadStatusColor();
    // if (!leadColors) {
    //   this.setLeadStatusColor({
    //     New: '#3399ff',
    //     Open: '#1ecbe1',
    //     'In Progress': '#ffcd39',
    //     'Call back': '#9d4edd',
    //     'Closed': '#adb5bd',
    //   });
    // }
    //test build

    let dealColors = this.getDealStatusColor();
    // if (!dealColors) {
    //   this.setDealStatusColor({
    //     Open: '#3399ff',
    //     Loss: '#1ecbe1',
    //     'On Hold': '#ffcd39',
    //     Won: '#adb5bd',
    //   });
    // }
  }
}
